module.exports = __webpack_public_path__ + "img/screwdriver.734c38f9.svg";